<template>
    <form method='POST' v-on:submit.prevent="handleSubmit">
        <div class='m-portlet__body'>
            <Builder :active_panel="active_panel" :panels="panels" v-on:updatePanel='updatePanelParent' v-on:updateInputs='updateInputs'></Builder>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/modules/index`"></Buttons>
    </form>
</template>

<script>
import Builder from '../../core/module/Builder'
import Buttons from '../../core/form/Buttons'
export default {
  name: 'ModuleUpdateInputs',
  components: {Buttons, Builder},
  data () {
    return {
      panels: {},
      active_panel: 1
    }
  },
  methods: {
    updatePanelParent (variable) {
      this.panels = Object.assign({}, variable)
    },
    updateInputs (variable) {
      this.inputs = Object.assign({}, variable)
    },
    handleSubmit () {
      this.$http
        .put(process.env.API_URL + `/api/v1/admin/module-builder/update-inputs`, {
          inputs: this.panels,
          moduleName: this.$route.params.id
        }, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            this.$router.push('/admin/modules/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  mounted: function () {
    this.$emit('updateTitle', 'Update Inputs: ' + this.$route.params.id)

    this.$http
      .get(process.env.API_URL + `/api/v1/admin/module-builder/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        this.panels = res.data.data.inputs

        for (let it in this.panels) {
          if (this.active_panel === 1) {
            this.active_panel = it
          }
        }
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/module/ModuleUpdateInputs.vue